
import {
    stickerConfigurations,
    productConfigurations
} from './config.js';

import {updateArrowVisibility,captureSVGtoImages      
} from './utils.js';

import {
    updatePageTemplate
} from './drawFunctions.js';

import {close3DPreview ,initScene
} from './3dlogic.js';

import {
    getSKU

} from './script.js';
 
import interact from 'interactjs';
import { SVG } from '@svgdotjs/svg.js';
// First, declare the variables at the top of your script

let zIndexCounter = 2;;//repeatied in controls, may rethink

let currentIndex = 0; // Instead of const currentIndex = 0;

export function setCurrentIndex(newIndex) {
    currentIndex = newIndex; // Now it should work
}


const OVERLAY_TIMEOUT_DURATION = 2000;  // 4 seconds
let overlayTimeout;
let currentOverlay = null;

export function showItemOverlay(item, type) {
    hideOverlay();
    item.addClass('blue-border');
    applyBlueBorder(item);
    makeItemResizable(item);
    const controlBar = createOverlayControlBar(item);
    if (type === 'photo') {
        // Add/Remove specific controls for photos if necessary
    } else if (type === 'sticker') {
        // Add/Remove specific controls for stickers if necessary
    }
    positionOverlayControlBar(controlBar, item.node);
    makeOverlayDraggable(controlBar);
    resetOverlayTimeout();
    updateItemIdDisplay(controlBar, item);
}


function updateItemIdDisplay(controlBar, item) {
    const itemIdDisplay = controlBar.querySelector('.item-id-display');
    if (itemIdDisplay) {
        console.log(`ID: ${item.node.getAttribute('data-item-id') || 'N/A'}`);
    }
}

export function createOverlayControlBar(item) {
    // Check if an overlay already exists; if so, remove it
    const existingOverlay = document.querySelector('.overlay-control-bar');
    if (existingOverlay) {
        existingOverlay.remove();
    }

    const overlayControlBar = document.createElement('div');
    overlayControlBar.className = 'overlay-control-bar';
    overlayControlBar.addEventListener('click', event => event.stopPropagation());

    const buttons = [ 'delete', 'scale', 'close'];//'rotate'
    buttons.forEach(btnType => {
        const btn = document.createElement('div');
        btn.className = `icon ${btnType}`;
        const icon = document.createElement('i');

        if (btnType === 'delete') {
            icon.className = 'fas fa-trash-alt';
            icon.style.color = 'red';
            btn.title = 'Delete';
        } else if (btnType === 'rotate') {
            icon.className = 'fas fa-redo';
            btn.title = 'Rotate';
        } else if (btnType === 'scale') {
            icon.className = 'fas fa-expand-arrows-alt';
            btn.title = 'Scale';
        } else if (btnType === 'close') {
            icon.className = 'fas fa-times';
            btn.title = 'Close';
        }

        btn.appendChild(icon);
        btn.addEventListener('click', () => {
            handleButtonClick(btnType, item);
            if (btnType !== 'close') {
                hideOverlay();
            }
        });
        overlayControlBar.appendChild(btn);
    });

    const itemId = item.node.getAttribute('data-item-id');
    const itemIdDiv = document.createElement('div');
    itemIdDiv.className = 'item-id-display';
    console.log(`ID: ${itemId}`);
    overlayControlBar.appendChild(itemIdDiv);

    document.body.appendChild(overlayControlBar);
    currentOverlay = overlayControlBar;

    return overlayControlBar;
}


function handleButtonClick(type, item) {
    if (type === 'delete') {
        deleteItemFromCanvas(item);
        hideOverlay();
    } else if (type === 'rotate') {
        rotateItemOnCanvas(item);
    } else if (type === 'scale') {
        scaleItemOnCanvas(item);
    } else if (type === 'close') {
        hideOverlay();
    }
}
function deleteItemFromCanvas(item) {
    item.remove();
}
function rotateItemOnCanvas(item) {
    // Check if the item is an SVG <image> element
console.log (item);

    // Create a rotation handle
    const handle = document.createElement('div');
    handle.style.width = '20px';
    handle.style.height = '20px';
    handle.style.backgroundColor = 'blue';
    handle.style.position = 'absolute';
    handle.style.borderRadius = '10px';
    handle.style.cursor = 'pointer';
    document.body.appendChild(handle);

    // Position the handle above the center of the sticker
    positionRotationHandle(handle, item);

    // Enable rotation using InteractJS
    interact(handle).draggable({
        listeners: {
            move(event) {
                applyRotationToSticker(item, event);
            }
        }
    });
}

function positionRotationHandle(handle, sticker) {
    const bbox = sticker.getBBox();
    const matrix = sticker.getScreenCTM();
    const svgPoint = sticker.ownerSVGElement.createSVGPoint();
    svgPoint.x = bbox.x + bbox.width / 2;
    svgPoint.y = bbox.y - 30; // 30px above the sticker
    const pointTransformed = svgPoint.matrixTransform(matrix);

    handle.style.left = `${pointTransformed.x - 10}px`; // Center the handle
    handle.style.top = `${pointTransformed.y - 10}px`;
}

function applyRotationToSticker(sticker, event) {
    const bbox = sticker.getBBox();
    const matrix = sticker.getScreenCTM();
    const center = {
        x: matrix.e + bbox.x + bbox.width / 2,
        y: matrix.f + bbox.y + bbox.height / 2
    };
    const radians = Math.atan2(event.clientY - center.y, event.clientX - center.x);
    const angle = radians * (180 / Math.PI);
    sticker.setAttribute('transform', `rotate(${angle}, ${center.x}, ${center.y})`);
}

function scaleItemOnCanvas(item) {
    // Set up InteractJS resizable interaction on the item
    interact(item.node).resizable({
        // Define the edges that can be used to scale the item
        edges: { left: true, right: true, bottom: true, top: true },
        // Define listeners for resize events
        listeners: {
            // This function is called every time the item is resized
            move(event) {
                let { x, y } = event.target.dataset;

                // Update the element's style
                Object.assign(event.target.style, {
                    width: `${event.rect.width}px`,
                    height: `${event.rect.height}px`,
                    // Update the position to compensate for the resizing from top/left
                    transform: `translate(${event.deltaRect.left}px, ${event.deltaRect.top}px)`
                });

                // Update the position attributes in the dataset
                x = (parseFloat(x) || 0) + event.deltaRect.left;
                y = (parseFloat(y) || 0) + event.deltaRect.top;
                Object.assign(event.target.dataset, { x, y });
            }
        },
        // Enable inertia throwing
        inertia: true
    });
    
    // Ensure the item can be scaled by setting an initial size in the dataset
    if (!item.node.dataset.width) {
        item.node.dataset.width = item.node.offsetWidth;
        item.node.dataset.height = item.node.offsetHeight;
    }
}

export function positionOverlayControlBar(controlBar, targetElement) {
    const rect = targetElement.getBoundingClientRect();
    controlBar.style.top = `${rect.top - controlBar.offsetHeight}px`;
    controlBar.style.left = `${rect.left + (rect.width / 2) - (controlBar.offsetWidth / 2)}px`;
    controlBar.style.zIndex = zIndexCounter + 1;
}

export function hideOverlay() {
    if (currentOverlay) {
        document.body.removeChild(currentOverlay);
        currentOverlay = null;
    }
}

export function resetOverlayTimeout() {
    if (overlayTimeout) {
        clearTimeout(overlayTimeout);
    }
    overlayTimeout = setTimeout(hideOverlay, OVERLAY_TIMEOUT_DURATION);
}

// Utility functions
export function applyBlueBorder(element) {
    element.addClass('blue-border');
    element.node.style.border = '2px solid blue';
}

export function removeBlueBorder(element) {
    element.removeClass('blue-border');
    element.node.style.border = 'none';
}

export function makeItemResizable(item) {
    let wasDragged = false;

    // Create SVG rectangles as resizing handles for each corner of the item
    const createResizeHandle = (parent, x, y) => {
        const handle = document.createElementNS("http://www.w3.org/2000/svg", "rect");
      //  handle.setAttribute("x", x);
      //  handle.setAttribute("y", y);
       // handle.setAttribute("width", 10);
      //  handle.setAttribute("height", 10);
      //  handle.setAttribute("fill", "blue");
     //   handle.setAttribute("class", "resize-handle");
        parent.appendChild(handle);
        return handle;
    };

    const bbox = item.node.getBBox();
    createResizeHandle(item.node.parentNode, bbox.x - 5, bbox.y - 5);                  // top-left
    createResizeHandle(item.node.parentNode, bbox.x + bbox.width - 5, bbox.y - 5);     // top-right
    createResizeHandle(item.node.parentNode, bbox.x - 5, bbox.y + bbox.height - 5);    // bottom-left
    createResizeHandle(item.node.parentNode, bbox.x + bbox.width - 5, bbox.y + bbox.height - 5); // bottom-right

    interact(item.node).resizable({
        edges: { left: true, right: true, bottom: true, top: true },
        listeners: {
            resize(event) {
                const { width, height } = event.rect;
                item.size(width, height);

                // Assuming every item (sticker or photo) has a unique ID stored in 'data-id'
                const itemId = item.node.getAttribute('data-id');
        
                // Store the new dimensions in cardState
                if (item.node.classList.contains('user-photo-placeholder')) {
                    // Find and update the photo in cardState
                    const photo = cardState[productType][currentPage].user_photo.find(p => p.id === itemId);
                    if (photo) {
                        photo.width = width;
                        photo.height = height;
                    }
                } else {
                    // Find and update the sticker in cardState
                    const sticker = cardState[productType][currentPage].stickers.find(s => s.id === itemId);
                    if (sticker) {
                        sticker.width = width;
                        sticker.height = height;
                    }
                }
        
                // Store the updated cardState in localStorage
                //localStorage.setItem('cardState', JSON.stringify(cardState));
            }
        }
    });
}


export function makeOverlayDraggable(overlay) {
    let x = 0;
    let y = 0;

    interact(overlay).draggable({
        listeners: {
            start(event) {
                event.stopPropagation();
                x = parseInt(overlay.style.left || 0);
                y = parseInt(overlay.style.top || 0);
            },
            move(event) {
                  event.stopPropagation();
                x += event.dx;
                y += event.dy;

                overlay.style.left = x + 'px';
                overlay.style.top = y + 'px';
            }
        }
    });
}


export function open3DPreview() { 


    initScene();

    const preview3DElement = document.getElementById('threeJSContainer');

    if (preview3DElement) {
        const position = preview3DElement.getBoundingClientRect();
        console.log('Preview3D position:', position);

        const canvasContainer = document.getElementById('canvas-container');

        // Since getBoundingClientRect() provides the position relative to the viewport,
        // we subtract the container's left position to get the position relative to the container.
        const scrollTo = position.left - canvasContainer.getBoundingClientRect().left;

        canvasContainer.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
        }); currentPage='feature_3d';
        updateArrowVisibility();
       

    } else {
        console.log("The preview3D div was not found in the DOM.");
    }
}
let isMoving = false;  // Initialize at the top of your script
let scrollTimeout;  // For debouncing the scroll event


function dispatchCarouselMoveEvent(direction) {
    // Create a new event with a custom name and details
    const event = new CustomEvent('off_3d', {
    
    });

    // Dispatch the event on the document or a specific element
    document.dispatchEvent(event);
}
//handle 3d off if outside control used
document.addEventListener('off_3d', function(e) {
  console.log('event');

    // Check if the 3D feature is active before moving the carousel
   

    close3DPreview();
 
});

function is3DFeatureActive() {
   
    return currentPage === 'feature_3d';
}
export function moveCarousel(direction, swipePages = 1, performScroll = true) {
    if (isMoving) return; // Exit if a move operation is already in progress

    isMoving = true; // Set the lock
    console.log('Before update:', currentPage);

    const canvasContainer = document.getElementById('canvas-container');
    const { value: cardType } = document.getElementById('cardType');
    const SKU = getSKU(); // A function to get the current SKU
    let validPages = Object.keys(productConfigurations[[SKU]]);
    const cardWidth = 340;
 
    // Dynamically include 'feature_3d' if it exists in the product configuration
    if (productConfigurations[cardType]['feature_3d'] && !validPages.includes('feature_3d')) {
        validPages.push('feature_3d');
    }

    // Get the index of the current page
    const currentIndex = validPages.indexOf(currentPage);

    // Calculate the target index based on direction and swipePages
    let targetIndex = direction === 'next' ? currentIndex + swipePages : currentIndex - swipePages;
    // Keep the target index within the valid range
    targetIndex = Math.max(0, Math.min(targetIndex, validPages.length - 1));

    // Check if the page actually needs to be updated
    if (targetIndex === currentIndex) {
        // No change required, release the lock
        isMoving = false;
        return;
    }

    // Function to update internal state and release lock
    const finalizeMove = () => {
        currentPage = validPages[targetIndex];
        console.log('Updated currentPage:', currentPage);

        // Code to update visibility of arrows and any other UI elements
        updateArrowVisibility();

        
        
        // Example of checking for a 3D feature page
        if (currentPage === 'feature_3d') {
            const featureConfig = productConfigurations[SKU].feature_3d;
            initScene(featureConfig.type, featureConfig.page_size);
        } else {
            // Process for other pages
            // You might need some logic here for handling different types of pages or features
            close3DPreview();
            // updatePageTemplate(currentPage); // If needed to update the page template
        }

        isMoving = false; // Release the lock
    };

    if (performScroll) {
        // Scroll to the new page
        const targetContainer = document.getElementById(`${validPages[targetIndex]}-container`);
        const scrollPosition = targetContainer ? targetContainer.offsetLeft : cardWidth * targetIndex;
        
        canvasContainer.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
        });

        // Finalize the move once scrolling finishes
        canvasContainer.addEventListener('scroll', function onScroll() {
            clearTimeout(scrollTimeout); // Clear any previous timeouts to prevent multiple triggers
            scrollTimeout = setTimeout(() => {
                canvasContainer.removeEventListener('scroll', onScroll);
                finalizeMove();
            }, 100); // Debounce time for scroll event
        });
    } else {
        // If scrolling is not needed, just finalize the move
        finalizeMove();
    }
}